import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export default function DashboardShell({ title, subtitle, children }: Props) {
  const { state, logout } = useAuth();

  return (
    <div className="min-h-screen bg-black text-white">
      <header className="border-b border-gray-800 bg-gray-950/80">
        <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <h1 className="text-2xl font-semibold">{title}</h1>
            {subtitle && <p className="text-sm text-gray-400">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-3 text-sm">
            <Link to="/" className="text-gray-300 hover:text-white">Πίσω στο site</Link>
            {state.user && (
              <button onClick={logout} className="text-red-300 hover:text-red-200">Αποσύνδεση</button>
            )}
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6">
        {children}
      </main>
    </div>
  );
}
